import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, FormGroup, FormControl } from 'react-bootstrap';
import { UploadInstructions, DeleteButton, DownloadButton } from 'ctia-ui';
import { handleDocTitleChange, handleDocFileChange } from 'actions/request';
import { fetchTestReports, testReportDownload } from 'actions/tests';
import { deleteTestReport } from 'actions/uploads';
import { hasReportDocuments, countReports } from 'helpers/RequestTestsHelper';
import InputFile from 'components/form/InputFile';
import { cutFileExtension } from 'helpers/StringHelper';

class LabResultUpload extends Component {
  onDelete = (testId, slot) => {
    const { deleteTestReport, fetchTestReports } = this.props;
    return deleteTestReport(testId, slot).then(() => fetchTestReports(testId));
  };

  onSelectFile = (index, event) => {
    const { handleDocFileChange, handleDocTitleChange, request } = this.props;

    // set file description as file name by default (w/o file extension)
    const fileName = cutFileExtension(event.target.files[0].name);

    // create event for changing description action manually
    const titleChangeEvent = { id: 'testResults', target: { value: fileName } };

    handleDocFileChange(index, request.testResults, event);
    handleDocTitleChange(index, request.testResults, titleChangeEvent);
  };

  render() {
    const { labs, show, request, handleDocTitleChange } = this.props;

    // waiting labs too
    // to be sure that render will be
    // at the same time as lab result form
    if (!show || !labs) return null;

    const results = request.testResults;
    const hasReports = hasReportDocuments(results);
    const reportsCount = countReports(results);

    return (
      <div>
        <h3>Upload Results</h3>
        <Table striped condensed hover>
          <thead>
            <tr>
              <th>Document Title</th>
              <th>Select Document</th>
              {hasReports && <th style={{ width: 250 }}>Actions</th>}
            </tr>
          </thead>
          <tbody>
            {results.map((item, i) => {
              return (
                <tr key={i}>
                  <td>
                    <FormGroup controlId="testResults" bsSize="small">
                      <FormControl
                        type="text"
                        value={item.title}
                        onChange={handleDocTitleChange.bind(this, i, results)}
                      />
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup controlId="testResults">
                      <InputFile
                        id={`report${i}`}
                        name="testResults"
                        onChange={this.onSelectFile.bind(this, i)}
                        file={item.file}
                        disabled={false}
                      />
                    </FormGroup>
                  </td>
                  {hasReports && (
                    <td>
                      {item.docId > 0 && reportsCount > 1 && (
                        <DeleteButton
                          size="small"
                          action={this.onDelete.bind(
                            this,
                            item.requesttestid,
                            item.slot
                          )}
                        />
                      )}
                      {item.docId > 0 && (
                        <DownloadButton
                          size="small"
                          action={this.props.testReportDownload.bind(
                            this,
                            item,
                            request
                          )}
                        />
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>
        <UploadInstructions />
      </div>
    );
  }
}

function mapStateToProps({ request, tests, labs }) {
  return { request, tests, labs };
}

export default connect(
  mapStateToProps,
  {
    handleDocTitleChange,
    handleDocFileChange,
    deleteTestReport,
    fetchTestReports,
    testReportDownload
  }
)(LabResultUpload);



// WEBPACK FOOTER //
// ./src/containers/testResult/LabResultUpload.js